const hotspotIDs = {
  button: 'HotSpotButton_',
  template: 'HotSpotTemplate_'
};

// find the banner
const banner = document.querySelector('.js-inspiration-banner');
// find the details
const details = banner.querySelector('.js-inspiration-banner__details');
// find the hotspots
const hotspots = [...banner.querySelectorAll('.js-inspiration-banner__hotspot')];
let updateTimeout = null;
const timer = {
  current: new Date().getTime(),
  previous: 0,
  transition: 500
};
function getCurrentTemplate() {
  return details.firstElementChild;
}
function updateDetails(template) {
  // Get the current time
  timer.current = new Date().getTime();
  clearTimeout(updateTimeout);

  // Set a delay variable to be the transition time minus the time since the last click with a minimum of 0
  const delay = Math.min(timer.current - timer.previous, timer.transition);

  // Set the previous time to the current time
  timer.previous = timer.current;

  // Add the hidden class to the details
  details.classList.add('hidden');
  updateTimeout = setTimeout(() => {
    details.innerHTML = template.innerHTML;
    setTimeout(() => details.classList.remove('hidden'), 10);
  }, delay);
}

// loop all the hotspots
hotspots.forEach(button => {
  // Grab its ID
  const ID = button.id.replace(hotspotIDs.button, '');
  // Find the template with the same ID
  const template = banner.querySelector(`#${hotspotIDs.template}${ID}`);

  // If the template does not exist, return
  if (!template) return button.remove();

  // Add a click event to the button
  button.addEventListener('click', () => {
    // Update the details with the template
    updateDetails(template);
  });
});